/** A Help Center link that leads nowhere: search instead of a dead end. */
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HelpShell from '@/components/help/HelpShell';
import HelpSearch from '@/components/help/HelpSearch';

export default function HelpNotFound() {
  return (
    <HelpShell showSearch={false}>
      <Helmet>
        <title>Article not found | Defera Help Center</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="mx-auto max-w-2xl px-4 sm:px-6 py-24 text-center">
        <h1 className="text-[30px] font-semibold text-white">We couldn’t find that article</h1>
        <p className="mt-3 text-[16px] text-white/65">It may have moved. Search for what you need, or go back to the <Link to="/help" className="text-[#AAB4D6] underline decoration-white/25 underline-offset-2 hover:text-white">Help Center</Link>.</p>
        <div className="mt-8 text-left">
          <HelpSearch variant="compact" autoFocus />
        </div>
      </div>
    </HelpShell>
  );
}
